import { FormattedMessage } from 'react-intl';
import { useTheme } from 'styled-components';
import PropTypes from 'prop-types';

import Button from '../../../components/Button';
import Icon from '../../../components/Icon';
import Text from '../../../components/Text';
import Box from '../../../components/layout/Box';

const Header = ({ onClose, title }) => {
  const theme = useTheme();

  const { fontBasColor } = theme.colors;

  return (
    <Box className="w-100 align-items-center justify-content-center">
      <Box className="flex-grow-1">
        <Text variant="sectionTitle">{title}</Text>
      </Box>

      <Box
        onClick={onClose}
        className="align-items-center"
        style={{ cursor: 'pointer' }}
      >
        <Button
          paddingHorizontal={6}
          backgroundColor="transparentColor"
          titleColor="fontBasColor"
        >
          <FormattedMessage defaultMessage="Stäng" />
        </Button>
        <Icon name="close-circle-outline" color={fontBasColor} />
      </Box>
    </Box>
  );
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
};

export default Header;
